/** TanStack Query keys. Realtime merges (realtime/integrate.ts) write into these. */
export const qk = {
  me: ["me"] as const,
  sites: ["sites"] as const,
  fleets: ["fleets"] as const,
  robots: (params?: { siteId?: string; fleetId?: string }) => ["robots", params ?? {}] as const,
  robotsAll: ["robots"] as const,
  robot: (id: string) => ["robot", id] as const,
  robotTelemetry: (id: string) => ["robot", id, "telemetry"] as const,
  robotTelemetryHistory: (id: string) => ["robot", id, "telemetry-history"] as const,
  robotTimeline: (id: string, params: Record<string, unknown>) => ["robot", id, "timeline", params] as const,
  robotErrors: (id: string) => ["robot", id, "errors"] as const,
  robotControl: (id: string) => ["robot", id, "control"] as const,
  /** Arm jog visibility confirmation for one teleop lease + authority generation (ADR-018 D7). */
  robotArmJogSession: (id: string, leaseId: string, generation: number) => ["robot", id, "armJogSession", leaseId, generation] as const,
  robotCommands: (id: string) => ["robot", id, "commands"] as const,
  robotCalibrations: (id: string) => ["robot", id, "calibrations"] as const,
  robotRecoveries: (id: string) => ["robot", id, "recoveries"] as const,
  robotDeployments: (id: string) => ["robot", id, "deployments"] as const,
  // Under the deployments key, so anything that refreshes deployments refreshes the preview too.
  deploymentPreview: (robotId: string, mapId: string) => ["robot", robotId, "deployments", "preview", mapId] as const,
  robotDiagnostics: (id: string) => ["robot", id, "diagnostics"] as const,
  robotMapImports: (id: string) => ["robot", id, "mapImports"] as const,
  mapImport: (id: string) => ["mapImport", id] as const,
  missions: (params?: Record<string, unknown>) => ["missions", params ?? {}] as const,
  missionsAll: ["missions"] as const,
  mission: (id: string) => ["mission", id] as const,
  maps: ["maps"] as const,
  map: (id: string) => ["map", id] as const,
  mapVersions: (id: string) => ["map", id, "versions"] as const,
  mapImage: (id: string, version: number) => ["map", id, "image", version] as const,
  mapWaypoints: (id: string) => ["map", id, "waypoints"] as const,
  mapPaths: (id: string) => ["map", id, "paths"] as const,
  mapValidate: (id: string) => ["map", id, "validate"] as const,
  mapRoutePlan: (id: string) => ["map", id, "route-plan"] as const,
  mapPlannedRoutes: (id: string, planId: string) => ["map", id, "route-plan", planId, "routes"] as const,
  mapLayers: (id: string, version: number) => ["map", id, "layers", version] as const,
  mapLayerPreview: (id: string, version: number, layerId: string, sha256: string) => ["map", id, "layers", version, layerId, "preview", sha256] as const,
  workflows: (mapId?: string) => ["workflows", mapId ?? "all"] as const,
  workflowsAll: ["workflows"] as const,
  workflow: (id: string) => ["workflow", id] as const,
  registry: ["registry"] as const,
  errorCatalog: ["errorCatalog"] as const,
  users: ["users"] as const,
  apiTokens: ["apiTokens"] as const,
  audit: (params: Record<string, unknown>) => ["audit", params] as const,
};
